import { motion } from "framer-motion";
import credibilityData from "../data/credibility.json";
import { useCmsDoc } from "../hooks/useCmsDoc";
import ConsentAwareEmbed from "../components/ConsentAwareEmbed";

const CertificationsPage = () => {
  const { data: accreditations } = useCmsDoc(
    "credibility",
    "accreditations",
    credibilityData.accreditations
  );
  const catalogUrl =
    accreditations?.catalog?.embedUrl ||
    credibilityData?.accreditations?.catalog?.embedUrl;

  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      exit={{ opacity: 0 }}
      className="pt-24 pb-12 bg-surface min-h-screen flex flex-col"
    >
      <div className="container mx-auto px-6 flex-grow flex flex-col">
        <h1 className="font-display text-4xl font-black text-brand-dark tracking-tighter mb-8">
          Nuestras Acreditaciones <span className="text-brand-primary">y Certificaciones</span>
        </h1>
        <div style={{ position: "relative", paddingTop: "max(60%, 324px)", width: "100%", height: 0 }}>
          <ConsentAwareEmbed
            title="Catálogo Heyzine"
            description="El catálogo se carga desde Heyzine (tercero). Actívelo si acepta cookies de contenido externo."
            className="absolute inset-0 rounded-none h-full border-0"
            minHeight="100%"
          >
            <iframe
              style={{ position: "absolute", border: "none", width: "100%", height: "100%", left: 0, top: 0 }}
              src={catalogUrl}
              title="AGDYSA - Certificaciones y Acreditaciones"
              seamless="seamless"
              scrolling="no"
              frameBorder="0"
              allowTransparency="true"
              allowFullScreen={true}
            />
          </ConsentAwareEmbed>
        </div>
      </div>
    </motion.div>
  );
};

export default CertificationsPage;